import { sample } from 'effector';
import {
  $ABGradient,
  $ABModal,
  $activeLayer,
  $currentCategory,
  $filterModal,
  $hsCodes,
  $worldPolygons,
  gradient_init,
} from './stores.js';
import {
  applyFiltersEv,
  changeABModalEv,
  changeActiveLayerEv,
  changeCurrentCategoryEv,
  changeFilterModalEv,
  resetABModalEv,
  resetFilterModalEv,
  updateGradientByHSEv,
} from './events.js';
import {
  getABBucketsFx,
  getABCountriesFx,
  getABCountriesHSDataFx,
  getABHSCodesFx,
} from './effects.js';
import { getLessColors } from '../../utils/gradient-utils.js';
import { gradient_colors } from '../../dictionaries/gradient_dictionary.js';

$currentCategory.on(changeCurrentCategoryEv, (state, payload) => payload);

$activeLayer.on(changeActiveLayerEv, (state, payload) => payload);

$ABModal
  .on(changeABModalEv, (state, payload) => {
    if (typeof payload === 'boolean') return payload;
    return !state;
  })
  .reset(resetABModalEv);

// sample({
//   source: $worldPolygons,
//   clock: getABCountriesFx.doneData,
//   fn: (source, clock) => {
//     const test = source.map((item) => {
//       const data = clock.find((elem) => +elem.code === item.properties.id);
//       return {
//         ...item,
//         properties: {
//           name: data?.name_ru || item.properties.name,
//           id: item.properties.id,
//         },
//       };
//     });
//     debugger;
//   },
// });

$filterModal
  .on(changeFilterModalEv, (state, payload) => {
    if (typeof payload === 'boolean') return payload;
    return !state;
  })
  .reset(resetFilterModalEv);

sample({
  clock: getABHSCodesFx.doneData,
  fn: (clock) => {
    return clock.map((item) => {
      return {
        label: `${item.hscode} - ${item.product_name}`,
        value: item.hscode,
      };
    });
  },
  target: $hsCodes,
});

sample({
  source: $worldPolygons,
  clock: getABCountriesHSDataFx.doneData,
  fn: (source, clock) => {
    return source.map((item) => {
      const data = clock.data.find(
        (elem) =>
          +elem.country_code === item.properties.id &&
          elem.type === 'import_from'
      );
      return {
        ...item,
        properties: {
          ...item.properties,
          ...data,
        },
      };
    });
  },
  target: [$worldPolygons, updateGradientByHSEv],
});

sample({
  clock: $currentCategory.updates,
  target: getABCountriesHSDataFx,
});

sample({
  source: [$worldPolygons, $activeLayer],
  clock: applyFiltersEv,
  filter: ([polygons, layer], clock) => layer !== 'tariff',
  fn: ([polygons, layer], clock) => {
    return {
      polygons,
      activeLayer: layer,
    };
  },
  target: getABBucketsFx,
});

sample({
  source: $activeLayer,
  clock: updateGradientByHSEv,
  filter: (source, clock) => source !== 'tariff',
  fn: (source, clock) => {
    return {
      polygons: clock,
      activeLayer: source,
    };
  },
  target: getABBucketsFx,
});

sample({
  source: [$worldPolygons, $activeLayer],
  clock: applyFiltersEv,
  filter: ([polygons, layer], clock) => layer === 'tariff',
  fn: (source, clock) => {
    return gradient_init;
  },
  target: $ABGradient,
});

sample({
  source: $activeLayer,
  clock: getABBucketsFx.doneData,
  fn: (source, clock) => {
    let colors;
    if (clock.length < 10) {
      colors = getLessColors(clock.length, false, false, false);
    } else {
      colors = gradient_colors.light;
    }
    if (source === 'cost_all') {
      colors = [...gradient_colors.light].reverse();
    }
    return {
      buckets: clock,
      colors,
    };
  },
  target: $ABGradient,
});
